import { queryOptions, useQuery } from '@tanstack/react-query';
import styled from 'styled-components';
import { queryKeys } from '@/api/utils/queryKeys';
import { modalAccordionStyles } from '@/components/ModalRenderer/components/styled';
import { Modal } from '@/components/ModalRenderer/Modal';
import TermsAndConditionsAccordion from '@/components/UK/credit/TermsAndConditionsAccordion';
import { cmsApi } from '@/integrations/sanity/api';

const StyledTermsAndConditions = styled(TermsAndConditionsAccordion)`
  ${modalAccordionStyles};
`;

const termsAndConditionsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.cms.termsAndConditions,
    queryFn: cmsApi.getTermsAndConditions,
    staleTime: Infinity,
  });

const TermsAndConditions = () => {
  const { data: termsAndConditionsData } = useQuery(termsAndConditionsQueryOptions());

  return (
    <Modal title="Terms and Conditions">
      <div className="flex flex-col gap-6">
        <p>{termsAndConditionsData?.lastUpdatedTitle}</p>

        <StyledTermsAndConditions />
      </div>
    </Modal>
  );
};

export default TermsAndConditions;
